import { render, staticRenderFns } from "./form-dialog-component.vue?vue&type=template&id=22700076&scoped=true"
import script from "./form-dialog-component.vue?vue&type=script&lang=ts"
export * from "./form-dialog-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22700076",
  null
  
)

export default component.exports